import { defineStore } from 'pinia'
import type { CustomFeature } from '@/libs/leaflet/featureManager'
import { cloneDeep } from 'lodash'

interface State {
  targetDownloadFeature: CustomFeature[]
  isSelectedAllFeature: boolean
  isOpenAlertModal: boolean
  isDownloaded: boolean
}

export const useOfflineDataDownloadProcessStore = defineStore('offlineDataDownloadProcess', {
  state: (): State => ({
    targetDownloadFeature: [],
    isSelectedAllFeature: false,
    isOpenAlertModal: false,
    isDownloaded: false
  }),

  getters: {
    getTargetDownloadFeature: state => cloneDeep(state.targetDownloadFeature),
    getIsSelectedAllFeature: state => state.isSelectedAllFeature,
    getIsOpenAlertModal: state => state.isOpenAlertModal,
    getIsDownloaded: state => state.isDownloaded
  },

  actions: {
    updateDownloadFeature(feature: CustomFeature[]) {
      this.targetDownloadFeature = feature
    },

    updateIsSelectAllFeature(isSelectedAllFeature: boolean) {
      this.isSelectedAllFeature = isSelectedAllFeature
    },

    updateIsOpenAlertModal(isOpenAlertModal: boolean) {
      this.isOpenAlertModal = isOpenAlertModal
    },

    updateIsDownloaded(isDownloaded: boolean) {
      this.isDownloaded = isDownloaded
    },

    clearTargetDownloadFeature() {
      this.targetDownloadFeature = []
    }
  }
})
